import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrgLoginDialogOptional } from '@/contexts/OrgLoginDialogContext';
import { resolveOrgSlugFromPublicPath } from '@/lib/resolveOrgBookingContext';
import {
  academyBookingLoginPath,
  publicBookingReturnUrlForLogin,
} from '@/pages/public/publicBooking/bookingPaths';
import type { OpenOrgLoginOptions } from '@/contexts/OrgLoginDialogContext';

type AcademyRouteTarget = string | { slug: string };

export function useOpenAcademyBookingLogin() {
  const orgLogin = useOrgLoginDialogOptional();
  const navigate = useNavigate();

  return useCallback(
    (
      academy: AcademyRouteTarget,
      lessonId: string,
      options?: {
        invitationToken?: string | null;
        waitlistEntryId?: string | null;
        manualInviteToken?: string | null;
      },
      loginOptions?: OpenOrgLoginOptions
    ) => {
      const returnPath = publicBookingReturnUrlForLogin(academy, lessonId, options);
      const orgSlug = resolveOrgSlugFromPublicPath();
      if (orgSlug !== null && orgLogin) {
        orgLogin.openOrgLogin(returnPath, loginOptions);
        return;
      }
      navigate(academyBookingLoginPath(academy, lessonId, options), {
        state: loginOptions
          ? { email: loginOptions.prefillEmail, message: loginOptions.message }
          : undefined,
      });
    },
    [navigate, orgLogin]
  );
}
